<template>
  <div>
    <el-button type="primary" @click="dialogFormVisible = true">立即咨询</el-button>
    <el-dialog title="给我们留言" :visible.sync="dialogFormVisible" @close="clear">
      <el-form v-model="form" style="text-align: left" ref="dataForm">
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入你的姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth" prop="tel">
          <el-input v-model="form.tel" autocomplete="off" placeholder="请输入你的联系方式"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth" prop="mail">
          <el-input v-model="form.mail" autocomplete="off" placeholder="请输入你的邮箱地址"></el-input>
        </el-form-item>
        <el-form-item label="问题" :label-width="formLabelWidth" prop="question">
          <el-input
            type="textarea"
            v-model="form.question"
            autocomplete="off"
            placeholder="请输入你的问题"
          ></el-input>
        </el-form-item>

        <el-form-item prop="id" style="height: 0">
          <el-input type="hidden" v-model="form.id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="addtime" style="height: 0">
          <el-input type="hidden" v-model="form.addtime" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "EditForm",
  data() {
    return {
      dialogFormVisible: false,
      form: {
        name: "",
        tel: "",
        mail: "",
        question: "",
      },
      formLabelWidth: "120px",
    };
  },
  methods: {
    clear() {
      this.form = {
        name: "",
        tel: "",
        mail: "",
        question: "",
      };
    },
    getTime() {
      setInterval(() => {
        this.nowtime = new Date().toLocaleString();
      }, 1000);
    },
    onSubmit() {
      this.$axios
        .post("/message", {
          name: this.form.name,
          tel: this.form.tel,
          mail: this.form.mail,
          question: this.form.question,
          addtime: this.getTime(),
        })
        .then((resp) => {
          if (resp && resp.status === 200) {
            this.dialogFormVisible = false;
            this.$emit("confirm");
          }
        });
    },
  },
};
</script> 

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/home/EditForm.vue